import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import {Container, Row, Col, Card, Alert, CardBody, Button, Label, Input} from "reactstrap";

import { connect, useDispatch } from "react-redux";
import withRouter from 'components/Common/withRouter';

import Breadcrumb from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper";
import avatar from "../../assets/images/users/user-4.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import { useNavigate } from 'react-router-dom';

const UpdatePassword = props => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [email, setemail] = useState(JSON.parse(localStorage.getItem("authUser")).email);
  const [name, setname] = useState(`${JSON.parse(localStorage.getItem("authUser")).last_name} ${JSON.parse(localStorage.getItem("authUser")).first_name}`);
  const [idx, setidx] = useState(JSON.parse(localStorage.getItem("authUser")).phone);

  const [oldpassword, setOldpassword]= useState("");
  const [newpassword, setNewpassword]= useState("")
  const [confirm, setConfirm]= useState("")
  const [error, setError] =useState("")
  const [success, setSuccess] =useState("")

  const checkInput = () => {
    if (!oldpassword || !oldpassword.trim()) { setError('Saisir l\'ancien mot de passe svp'); return false;}
    if (!newpassword || !newpassword.trim()) { setError('Saisir le nouveau mot de passe svp'); return false;}
    if (newpassword.length<5) { setError('Le nouveau mot de passe doit comporter 5 caractères minimum'); return false;}
    if (!confirm || !confirm.trim()) { setError('Saisir la confirmation du nouveau mot de passe svp'); return false;}
    if (newpassword!=confirm) { setError('Le nouveau mot de passe et sa confirmation doivent être identique'); return false;}
      setError("")
      return true;
  };

  const updatePassword= ()=>{
      const inputError = checkInput();
      if (inputError) {
        const jsonData= JSON.stringify({old_password: oldpassword, new_password: newpassword });
        // console.log(jsonData);
        fetch(`${url.BACKEND_URL}/users/update-password/${JSON.parse(localStorage.getItem("authUser")).id}`, { method: 'PUT',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log("UserUpdated", responseJson.data);
          if (responseJson.status==200) {  
            setSuccess(responseJson.message)
            setTimeout(() => { history("/logout") }, 400);
          }
          else { setError(responseJson.message) }
        }) .catch((error) => { console.log(error); }); 
      }
    }
  document.title = "Profile | Veltrix - React Admin & Dashboard Template";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="AMAVIE" breadcrumbItem="Modifier mot de passe" />

          <Row>
            <Col lg="12">
              {props.error && props.error ? (
                <Alert color="danger">{props.error}</Alert>
              ) : null}
              {props.success ? (
                <Alert color="success">{props.success}</Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="align-self-center flex-1">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Changer votre mot de passe</h4>

          <Card>
            <CardBody>
              <Row>
                <div className="form-group col-md-4">
                  <Label className="form-label">Mot de passe actuel</Label>
                  <Input
                    name="username"
                    className="form-control"
                    placeholder="Mot de passe actuel"
                    type="password"
                    onChange={(event)=>setOldpassword(event.target.value)}
                    value={oldpassword}
                  />
                </div>
                <div className="form-group col-md-4">
                  <Label className="form-label">Nouveau mot de passe</Label>
                  <Input
                    name="username"
                    className="form-control"
                    placeholder="Nouveau mot de passe"
                    type="password"
                    onChange={(event)=>setNewpassword(event.target.value)}
                    value={newpassword}
                  />
                </div>
                <div className="form-group col-md-4">
                  <Label className="form-label">Confirmez le nouveau mot de passe</Label>
                  <Input
                    name="username"
                    className="form-control"
                    placeholder="Confirmez nouveau mot de passe"
                    type="password"
                    onChange={(event)=>{setConfirm(event.target.value)}}
                    value={confirm}
                  />
                </div>
                <div className="text-center mt-4">
                  <strong className="text-danger">{error}</strong>
                  <strong className="text-success">{success}</strong>
                </div>
                <div className="text-center mt-4">
                  <Button onClick={()=>{updatePassword()}} type="button" color="primary"> VALIDEZ LA MODIFICATION DU MOT DE PASSE </Button>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

UpdatePassword.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UpdatePassword)
);
